import {
  GETAUDIT,
  GETAUDIT_SUCCESS,
  GETAUDIT_ERROR,
    getAuditsSuccess,
    getAuditsError,
    setAudits,

    
  } from "../../actions/audit";
  import { apiRequest } from "../../actions/api";
  import { notification_types } from "../../../js/constants";
import { setNotification } from "../../actions/notification";

  export const getAuditflow = ({ dispatch }) => (next) => (action) => {
    next(action);
  
    if (action.type === GETAUDIT) {
      dispatch(
        apiRequest(
          "GET",
          "/apiCall.php?apiCall=GetAuditData",
          action.payload,
          null,
          getAuditsSuccess,
          getAuditsError,
          false,
          "[Audits]"
        )
      );
    }
  };

  export const processgetAudits = ({ dispatch }) => (next) => (action) => {
    next(action);

    if (action.type === GETAUDIT_SUCCESS) {
        dispatch(setAudits(action.payload.data));
        
    }

    if (action.type === GETAUDIT_ERROR) {
     
    }
  };
  
  
  export const AuditMdl = [
    getAuditflow,
    processgetAudits
  ];